import Axios from 'api/axios'
import type { ExternalCustomer, ExternalCustomerResponse, GroupingConfig, GroupingConfigResponse, TravelManagementCompany } from '../types'

const basePath = (customerId: string) => `/bo/v1/customers/${customerId}/travel-card`

export const getExternalCustomer = (customerId: string): Promise<ExternalCustomer | null> =>
  Axios.get<ExternalCustomerResponse>(`${basePath(customerId)}/external-customer`).then(({ data }) => data.data ?? null)

export const registerExternalCustomer = (customerId: string, externalCustomer: ExternalCustomer): Promise<void> =>
  Axios.put(`${basePath(customerId)}/external-customer`, externalCustomer).then(() => undefined)

export const getGroupingConfig = (customerId: string, tmc: TravelManagementCompany): Promise<GroupingConfig | null> =>
  Axios.get<GroupingConfigResponse>(`${basePath(customerId)}/grouping-config/${tmc}`).then(({ data }) => data.data ?? null)

export const registerGroupingConfig = (customerId: string, tmc: TravelManagementCompany, groupingConfig: GroupingConfig): Promise<void> =>
  Axios.put(`${basePath(customerId)}/grouping-config/${tmc}`, groupingConfig).then(() => undefined)
